module.exports = __webpack_public_path__ + "static/media/available-apple-store.be7f96ac.png";